import Icon from '../components/Icon.vue'

Icon.register({
  'window-minimize': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 352H48C21.5 352 0 373.5 0 400V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V400C512 373.5 490.5 352 464 352z'
      }
    ]
  }
})
